import { Tag, Tooltip } from "antd";

export type TagItem = { tag: string; value: string };

function LimitedTags({
  tags,
  maxVisible = 3,
  reportId
}: {
  reportId: string;
  tags: TagItem[];
  maxVisible?: number;
}) {
  if (!tags || tags.length === 0) return null;

  const visibleTags = tags.slice(0, maxVisible);
  const hiddenTags = tags.slice(maxVisible);

  /*
   * antd v6 changed two Tag defaults that this component relied on:
   *   - the default variant flipped from outlined to `filled`
   *     (`tag/hooks/useColor.js`: `nextVariant = contextVariant || 'filled'`),
   *     which drops the border and paints `tagBorderlessBg` behind the label;
   *   - the v5 base style's `margin-inline-end: 8px` is gone, and this wrapper
   *     only set a row gap, so adjacent tags rendered flush against each other
   *     and read as one merged pill.
   * Pin `variant="outlined"` and add the 8px column gap back explicitly.
   */
  return (
    <div
      className="flex flex-wrap gap-x-2 gap-y-1.5"
      data-testid={`limited-tags-${reportId}`}
    >
      {visibleTags.map((tag) => (
        <Tag
          key={`tag-${tag.value}-${reportId}`}
          variant="outlined"
          className="text-black text-opacity-90"
          data-testid={`limited-tag-${tag.value}-${reportId}`}
        >
          {tag.tag}
        </Tag>
      ))}

      {hiddenTags.length > 0 && (
        <Tooltip
          title={
            <div className="flex flex-col gap-1">
              {hiddenTags.map((tag) => (
                <Tag
                  key={`hidden-${tag.value}-${reportId}`}
                  variant="outlined"
                  className="text-xs text-black text-opacity-90 truncate"
                >
                  {tag.tag}
                </Tag>
              ))}
            </div>
          }
        >
          <Tag
            variant="outlined"
            className="text-xs text-black text-opacity-90 cursor-pointer flex items-center"
            data-testid={`limited-tags-hidden-count-${reportId}`}
          >
            +{hiddenTags.length}
          </Tag>
        </Tooltip>
      )}
    </div>
  );
}

export default LimitedTags;
